import { img_replace_rule } from './store.js';

export function imgFormatter(src) {

    for (let i = 0; i < img_replace_rule.length; i++) {
        const rule = img_replace_rule[i];
        src = src.replace(rule.match, rule.replace);
    }

    return src;
}